import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const Logo = styled('img')({
  width: 48,
  height: 48,
});

interface LoadingScreenProps {
  mesaira?: string;
  size?: 'small' | 'medium' | 'large';
}

function LoadingScreen({ mesaira = 'Loading...', size = 'medium' }: LoadingScreenProps) {
  const getSize = () => {
    switch (size) {
      case 'small':
        return 32;
      case 'large':
        return 64;
      default:
        return 48;
    }
  };

  return (
    <LoadingContainer>
      <LogoContainer>
        <Logo 
          src={`${process.env.PUBLIC_URL}/logo192.png`} 
          alt="MoreMe AI" 
          onError={(e) => {
            // Hide logo if it fails to load
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
        <Typography variant="h4" color="primary" fontWeight="bold">
          MoreMe AI
        </Typography>
      </LogoContainer>
      
      <CircularProgress 
        size={getSize()} 
        thickness={4}
        sx={{ mb: 2 }}
      />
      
      <Typography 
        variant="body1" 
        color="text.secondary"
        sx={{ textAlign: 'center', maxWidth: 300 }}
      >
        {mesaira}
      </Typography>
    </LoadingContainer>
  );
}

export default LoadingScreen;